import { render, staticRenderFns } from "./PremiumContent.vue?vue&type=template&id=283c4a4e&scoped=true&"
import script from "./PremiumContent.vue?vue&type=script&lang=js&"
export * from "./PremiumContent.vue?vue&type=script&lang=js&"
import style0 from "./PremiumContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PremiumContent.vue?vue&type=style&index=1&id=283c4a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c4a4e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BTable, BEmbed, BContainer} from 'bootstrap-vue'
    installComponents(component, {BTable, BEmbed, BContainer})
    

export default component.exports